import { useRuntimeConfig } from "#imports";
import { Intercom } from "@intercom/messenger-js-sdk";
import { getOAuthUser } from "~/utils/oauthUserStorage";

export default defineNuxtPlugin({
  name: "intercom",
  enforce: "post",
  async setup() {
    if (import.meta.env.STORYBOOK) return;
    const { public: config } = useRuntimeConfig();

    try {
      // Check if user exists before initializing
      const oauthUser = getOAuthUser();
      if (!oauthUser) {
        return;
      }

      const { isEmployee, isPhysio, isLocationManager, isPatient } = await useCurrentUserProfile();

      if (!config.intercom.enabled) {
        return;
      }

      if (isPatient) {
        return;
      }

      if (!isEmployee && !isPhysio && !isLocationManager) {
        return;
      }

      const { currentLocationId } = useCurrentLocation();
      const { user } = await useOAuth();

      if (!user.value?.profiles) {
        console.warn("No user profiles found");
        return;
      }

      const locationName =
        user.value.profiles.find((profile) => profile.location.id === currentLocationId.value)?.location.name ??
        "Unknown Location";

      const roles =
        user.value.profiles.find((profile) => profile.location.id === currentLocationId.value)?.roles ??
        "Unknown Location";

      const roleNames = Array.isArray(roles) ? roles.join(", ") : "Unknown Role";

      if (config.intercom.appId === undefined) {
        console.error("Intercom could not be instantiated because the APP ID is not configured properly.");
        return;
      }

      Intercom({
        app_id: config.intercom.appId,
        name: user.value.full_name,
        email: user.value.email,
        user_role: roleNames,
        location: locationName,
        api_base: "https://api-iam.eu.intercom.io",
      });
    } catch (error) {
      console.warn("Failed to initialize Intercom:", error);
    }
  },
});
